import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f07fbfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = { key: 4 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("正常")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("待审核")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("拒绝")
const _hoisted_10 = { key: 8 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("审核")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("重审")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("状态")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("拒绝")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "砍价商品" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'goods')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 0,
                  src: record.goods.image,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'goods_name')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(record.goods.name), 1))
              : _createCommentVNode("", true),
            (column.key === 'max_price')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(record.goods.max_price), 1))
              : _createCommentVNode("", true),
            (column.key === 'min_price')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(record.goods.min_price), 1))
              : _createCommentVNode("", true),
            (column.key === 'shop_name')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(record.shop.name), 1))
              : _createCommentVNode("", true),
            (column.key === 'logo')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 5,
                  src: record.shop.logo,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                  (record.status == 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "#2db7f5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.status == 0)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "#f50"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'audit_status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                  (record.audit_status == 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "#2db7f5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.audit_status == 0)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "green"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.audit_status == 2)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 2,
                        color: "#f50"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin":"5px"},
                    onClick: ($event: any) => ($setup.examine(record,1))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin":"5px"},
                    onClick: ($event: any) => ($setup.examine(record,2))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否禁用该商品?",
                    "ok-text": "正常",
                    "cancel-text": "禁用",
                    onConfirm: ($event: any) => ($setup.changeStatus(record,1)),
                    onCancel: ($event: any) => ($setup.changeStatus(record,0))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm", "onCancel"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      onOk: _cache[3] || (_cache[3] = ($event: any) => ($setup.onSubmit('formRef')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          rules: $setup.rules,
          model: _ctx.formState,
          name: "basic",
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            (_ctx.type == 1 )
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "审核意见",
                  name: "review_status"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.formState.review_status,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.review_status) = $event)),
                      style: {"width":"100%"},
                      placeholder: "请选择审核意见"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: 1 }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 2 }, {
                          default: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, {
              label: "审核备注",
              name: "description"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.description,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.description) = $event)),
                  placeholder: "审核备注"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}